module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CheckoutFreeDelivery":{"progress":{"text":"Nakupte ještě za {price} {textBold}","textBold":"a dopravu máte zdarma"},"active":"Doprava zdarma!"}},"en":{"CheckoutFreeDelivery":{"progress":{"text":"Buy for another {price} {textBold}","textBold":"and get free shipping"},"active":"Free shipping!"}}}')
  delete Component.options._Ctor
}
